import React from 'react';
import { motion } from 'framer-motion';
import { ShieldCheck } from 'lucide-react';
export const Guarantee = () => {
  return <section className="py-20 px-4 bg-brand-light" data-id="element-52">
      <div className="max-w-4xl mx-auto" data-id="element-53">
        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.5
      }} className="bg-white border-2 border-brand-gold p-8 sm:p-12 rounded-sm relative shadow-xl text-center" data-id="element-54">
          <div className="absolute -top-8 left-1/2 -translate-x-1/2 bg-brand-gold text-brand-dark w-16 h-16 rounded-full flex items-center justify-center shadow-lg" data-id="element-55">
            <ShieldCheck className="w-8 h-8" data-id="element-56" />
          </div>

          <h2 className="font-serif text-2xl sm:text-3xl font-bold text-brand-dark mt-4 mb-6 uppercase tracking-wide" data-id="element-57">
            The "Better-than-Money-Back" Challenge
          </h2>

          <p className="text-lg text-brand-dark/80 leading-relaxed max-w-2xl mx-auto" data-id="element-58">
            Try The AI Firewall for 30 days. If you don't feel 10x more
            confident about your job security, or if you don't reclaim at least
            5 hours of your week, I will refund every penny.
          </p>
          <p className="text-lg text-brand-dark/80 leading-relaxed max-w-2xl mx-auto mt-4 font-bold" data-id="element-59">
            You can even keep all the bonuses as my gift for trying. I'm taking
            100% of the risk.
          </p>
        </motion.div>
      </div>
    </section>;
};